import React, { Component } from 'react';
import { observer, Provider } from 'mobx-react';
import { inject } from 'mobx-react/index';
import { Redirect, Route, Switch } from 'react-router';
import { LivingRoomStore } from './livingroom.store';
import { WallsProvider } from './walls/walls.provider';
import { FloorProvider } from './floor/floor.provider';
import { CeilingProvider } from './ceiling/ceiling.provider';
import EmailLinkForm from '../_shared/emaillink/emaillink.form';

@inject('appStore')
@observer
export class LivingRoomProvider extends Component {
    livingRoomStore;
    emailLinkForm;

    constructor(props) {
        super(props);
        this.livingRoomStore = new LivingRoomStore();
        this.livingRoomStore.currentRoomNum = this.getRoomNum();

        this.emailLinkForm = new EmailLinkForm({
            store: props.appStore,
            appStore: props.appStore
        });
    }

    getRoomNum() {
        const { params } = this.props.match;

        if (typeof params.num === 'undefined') {
            return 1;
        }

        if (parseInt(params.num, 10) > this.livingRoomStore.numRooms) {
            return 1;
        }

        return parseInt(params.num, 10);
    }

    render() {
        return (
            <Provider
                livingRoomStore={this.livingRoomStore}
                emailLinkForm={this.emailLinkForm}
            >
                <Switch>
                    <Route
                        path='/livingroom/:num/walls/:id?'
                        component={WallsProvider}
                    />
                    <Route
                        path='/livingroom/:num/floor/:id?'
                        component={FloorProvider}
                    />
                    <Route
                        path='/livingroom/:num/ceiling/:id?'
                        component={CeilingProvider}
                    />
                    <Redirect to='/livingroom/1/walls' />
                </Switch>
            </Provider>
        );
    }
}
